module.exports = __webpack_public_path__ + "img/chevron-left-solid-colortext1.06d57b14.svg";